import React, { Component } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close'; // Import Close Icon
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'; // Import Shopping Cart Icon
import IconButton from '@mui/material/IconButton'; // For clickable icon
import { StripeService } from "../../../../service/manage/subscription/stripe_pg.service.js";
import { customerConstants } from "../../../../helper/constants.js";
import { sweetStatusAlert } from "../../../../components/common/SweetAlert.js";
import { CombankService } from "../../../../service/manage/subscription/combank_pg.service.js";
import { ExamTransactionService } from "../../../../service/manage/exam_subscription/examTransaction.service.js";
import {CartService} from "../../../../service/manage/exam_subscription/cart.service.js";
import './AssessPackageCard.css';
import SimpleReactValidator from 'simple-react-validator';
import { PromoService } from '../../../../service/settings/manage/promo_code.service.js';
import DiscountIcon from '@mui/icons-material/Discount';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
// import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Backdrop, Chip, CircularProgress, Typography } from '@mui/material';
import Lottie from 'lottie-react';
import animationData from './asserts/celebration.json';
import swal from 'sweetalert';
import { history } from "../../../../helper/history.js";
import { routes } from "../../../../helper/routes.js";

class BasicCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showPromoInput: false, // State to manage input field visibility
			showPromoButton: true, // State to manage promo button visibility
			promo_code: '',
			is_promo_applied: false,
			updated_amount_with_promo_code: null,
			applied_promo_code_details: null,
			is_submitting_promo_code: false,
			promo_response: null,
			showAnimation: false,
			is_submit_credit: false,
			claimedFreeCredits: false,
			total_credits_you_can_use:0,
			isAddingToCart: false,
		};
		this.createValidationsInstance();
	}

	componentDidMount() {
		// Listen for acceptance on payment terms and resume purchase

		window.addEventListener('creditPaymentAccepted', this.handlePackagePaymentAccepted);


		// Read raw value and check explicitly for null so that the string "0" is not treated as truthy
		const totalCreditsRaw = localStorage.getItem("totalCredits");
		if (totalCreditsRaw !== null) {
			const savedCredits = Number(totalCreditsRaw);
			// Only update state when we have a valid positive number (avoid setting to 0 unintentionally)
			if (!Number.isNaN(savedCredits) && savedCredits > 0) {
				this.setState({ total_credits_you_can_use: savedCredits });
			}

		}

	}

	componentWillUnmount() {
		// Cleanup: Remove the script when the component is unmounted
		if (this.props.customer !== customerConstants.EXO_CUSTOMER2) {
			const script = document.querySelector("script[src*='checkout.min.js']");
			if (script) {
				document.head.removeChild(script);
			}
		}
		// Remove paymentAccepted listener
		localStorage.removeItem("totalCredits");
	}
	createValidationsInstance() {
		this.validator = new SimpleReactValidator({
			validators: {
				greaterThanZero: {
					message: 'The :attribute must be greater than 0.',
					rule: (val, params, validator) => {
						return validator.helpers.testRegex(val, /^\d*\.?\d+$/) && parseFloat(val) > 0;
					},
					required: true,
				},
			},
		});
		this.updateValidator = new SimpleReactValidator();
	}

	componentWillUnmount() {
		// Cleanup: Remove the script when the component is unmounted
		if (this.props.customer !== customerConstants.EXO_CUSTOMER2) {
			const script = document.querySelector("script[src*='checkout.min.js']");
			if (script) {
				document.head.removeChild(script);
			}
		}
	}

	handlePromoClick = () => {
		this.validator.hideMessages();
		this.validator.purgeFields();
		this.setState({ promo_code: '', showPromoInput: true, showPromoButton: false, is_promo_applied: false, updated_amount_with_promo_code: null, is_submitting_promo_code: false });
	};

	handleCloseClick = () => {
		this.setState({ promo_code: '', showPromoInput: false, showPromoButton: true, is_promo_applied: false, updated_amount_with_promo_code: null, is_submitting_promo_code: false });
		this.validator.hideMessages();
		this.validator.purgeFields();
	};

	getSessionID = async (payment_obj) => {

		try {

			const res = await CombankService.getSessionIDAssessmentPackagePurchase(JSON.stringify(payment_obj));
			const session_id = res?.data.session.id;

			sessionStorage.setItem("checkout_session_id", res.data.session.id);
			sessionStorage.removeItem('pendingAssessmentCreditEnrollment');


			this.setState({ is_submit_credit: false })
			this.loadCheckoutScript(session_id);
		} catch (error) {
			sweetStatusAlert("Error!", "An error occurred while getting session ID.", "error");
			this.setState({ is_submit_credit: false })
		}
	};

	errorCallback = (error) => {
		this.setState({ is_submit_credit: false });
		if (this.props.customer !== customerConstants.EXO_CUSTOMER2) {
			const script = document.querySelector("script[src*='checkout.min.js']");
			if (script) {
				document.head.removeChild(script);
			}
		}
		sweetStatusAlert("Failed!", JSON.stringify(error), "error");
	};

	cancelCallback = () => {
		this.setState({ is_submit_credit: false });
		window.removeEventListener('popstate', this.handlePaymentCancelNavigation);
		// Clear any pending package purchase if user cancelled
		try { sessionStorage.removeItem('pendingAssessmentCreditEnrollment'); } catch (e) { /* ignore */ }
		if (this.props.customer !== customerConstants.EXO_CUSTOMER2) {
			const script = document.querySelector("script[src*='checkout.min.js']");
			if (script) {
				document.head.removeChild(script);
			}
		}
		sweetStatusAlert("Failed!", "Payment cancelled!", "info");
	};

	successCallback = () => {
		this.setState({ is_submit_credit: false });
		window.removeEventListener('popstate', this.handlePaymentCancelNavigation);
		if (this.props.customer !== customerConstants.EXO_CUSTOMER2) {
			const script = document.querySelector("script[src*='checkout.min.js']");
			if (script) {
				document.head.removeChild(script);
			}
		}
		sweetStatusAlert("Success!", "Payment successful!", "success");
	};

	loadCheckoutScript = (sessionID) => {
		const script = document.createElement("script");
		script.src = "https://cbcmpgs.gateway.mastercard.com/static/checkout/checkout.min.js";
		document.head.appendChild(script);
		script.onload = () => {
			window.Checkout.configure({
				session: {
					id: sessionID,
				},
			});

			window.Checkout.onComplete = this.successCallback;
			window.Checkout.onError = this.errorCallback;
			window.Checkout.onCancel = this.cancelCallback;

			if (window.Checkout) {
				if (this.props.customer !== customerConstants.EXO_CUSTOMER2) {
					const script = document.querySelector("script[src*='checkout.min.js']");
					if (script) {
						document.head.removeChild(script);
					}
				}
				window.Checkout.showPaymentPage();
			}
		};
	};

	handleAddCartClick = async () => {
		// Prevent double-clicks
		if (this.state.isAddingToCart) return;

		const confirmed = await swal({
			title: "",
			text: "Add this package to your cart?",
			icon: "info",
			buttons: {
				cancel: "Cancel",
				confirm: {
					text: "Yes, Add to Cart",
					value: true,
				}
			},
			dangerMode: false
		});

		if (!confirmed) {
			return;
		}

		this.setState({ isAddingToCart: true });

		try {
			const { pkg, selectedStudent } = this.props;
			const manage_user_id = sessionStorage.getItem("manage_user_id");
			const userType = sessionStorage.getItem("userType");
			const cartItem = {
				user_id: userType === "student" ? manage_user_id : selectedStudent,
				product_type: "credit_package",
				product_id: parseInt(pkg.type_id),
				quantity: 1,
				created_by: manage_user_id
			};

			const response = await CartService.addToCart(JSON.stringify(cartItem));

			if (response.success) {
				window.dispatchEvent(new Event('cart-updated'));
				this.setState({ isAddingToCart: false }, async () => {
					const navigateToCart = await swal({
						title: "Success!",
						text: "Added to cart successfully",
						icon: "success",
						buttons: {
							cancel: {
								text: "OK",
								value: false,
							},
							confirm: {
								text: "Go to Cart",
								value: true,
							}
						},
						dangerMode: false
					});

					if (navigateToCart) {
						history.push('/my-cart');
					}
				});
			} else {
				this.setState({ isAddingToCart: false });
				sweetStatusAlert("Error", response.message || "Failed to add to cart", "error");
			}
		} catch (error) {
			this.setState({ isAddingToCart: false });
			sweetStatusAlert("Error", "Failed to add to cart", "error");
			console.error("Add to cart error:", error);
		}
	};

	// handlePaymentPageClick = async (payment_obj) => {	
	// 	// Add popstate listener to handle browser back navigation
	// 	window.addEventListener('popstate', this.handlePaymentCancelNavigation);

	// 	// Update browser history to add cancel parameter for back navigation
	// 	const currentUrl = new URL(window.location.href);
	// 	currentUrl.searchParams.set('cancel', 'true');
	// 	window.history.pushState({ paymentInitiated: true }, '', currentUrl.toString());

	// 	await this.getSessionID(payment_obj);
	// };

	handlePaymentCancelNavigation = () => {
		// Clean up the URL by removing the cancel parameter
		const currentUrl = new URL(window.location.href);
		currentUrl.searchParams.delete('cancel');
		window.history.replaceState(null, '', currentUrl.toString());

		this.cancelCallback();
		window.removeEventListener('popstate', this.handlePaymentCancelNavigation);
	};

	manualPayment = async (payment_obj) => {
		ExamTransactionService.manualExamPayment(JSON.stringify(payment_obj))
			.then((response) => {
				if (response.success) {
					this.setState({ claimedFreeCredits: true })
					sweetStatusAlert("Success!", "Free credits added successfully", "success");
					this.setState({ is_submit_credit: false })
				} else {
					this.setState({ claimedFreeCredits: false })
					sweetStatusAlert("Failed!", "Failed to add free credits", "error");
					this.setState({ is_submit_credit: false })
				}
			})
	};

	// Handler called when user accepts payment terms on the PaymentTermsCondition page
	handlePackagePaymentAccepted = async () => {
		// Attempt to resume the payment using saved pending data
		let pending = {};
		try {
			pending = JSON.parse(sessionStorage.getItem('pendingAssessmentCreditEnrollment') || localStorage.getItem('pendingAssessmentCreditEnrollment') || '{}');
		} catch (e) {
			pending = {};
		}

		// Try route state as a last resort
		if (!pending || Object.keys(pending).length === 0) {
			const historyPending = history && history.location && history.location.state && history.location.state.pendingAssessmentCreditEnrollment;
			if (historyPending) pending = historyPending;
		}

		if (!pending || !pending.payment_obj) {
			// No pending payment found
			return;
		}

		this.setState({ is_submit_credit: true });
		// Start the payment session
		await this.getSessionID(pending.payment_obj);
	};

	calculatePackageRemainingTime = (level_end_date) => {
		const currentDate = new Date();
		const endDate = new Date(level_end_date);

		if (endDate <= currentDate) {
			return "Expired";
		}

		let years = endDate.getFullYear() - currentDate.getFullYear();
		let months = endDate.getMonth() - currentDate.getMonth();
		let days = endDate.getDate() - currentDate.getDate();

		// Adjust days
		if (days < 0) {
			months -= 1;
			const prevMonth = new Date(
				endDate.getFullYear(),
				endDate.getMonth(),
				0
			).getDate(); // days in previous month
			days += prevMonth;
		}

		// Adjust months
		if (months < 0) {
			years -= 1;
			months += 12;
		}

		if (years <= 0 && months <= 0 && days <= 0) {
			return "today";
		}

		const parts = [];

	if (years > 0) {
		parts.push(
			<>
				<strong>{years}</strong> year{years !== 1 ? "s" : ""}
			</>
		);
	}

	if (months > 0) {
		parts.push(
			<>
				<strong>{months}</strong> month{months !== 1 ? "s" : ""}
			</>
		);
	}

	if (days > 0 || parts.length === 0) {
		parts.push(
			<>
				<strong>{days}</strong> day{days !== 1 ? "s" : ""}
			</>
		);
	}

	if (parts.length === 1) return parts[0];
	if (parts.length === 2) return <>{parts[0]} and {parts[1]}</>;
	return <>{parts[0]}, {parts[1]} and {parts[2]}</>;
};

	isPackageVanish = (level_end_date) => {
		const currentDate = new Date();
		const endDate = new Date(level_end_date);

		if (isNaN(endDate.getTime())) {
			return false;
		}

		if (endDate <= currentDate) {
			return false; // Already expired
		}

		// total days remaining
		const timeDiff = endDate - currentDate;
		const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

		return daysRemaining < 30;
	};

	calculateCreditRemainingTime = (expiryType, expiryValue) => {
		const now = new Date();
		let endDate;

		if (expiryType === "date") {
			endDate = new Date(expiryValue);
			endDate.setHours(23, 59, 59, 999);
		} else if (expiryType === "days") {
			endDate = new Date(now);
			endDate.setDate(now.getDate() + Number(expiryValue));
		} else {
			return "Invalid expiry type";
		}

		if (endDate <= now) return "Expired";

		let years = endDate.getFullYear() - now.getFullYear();
		let months = endDate.getMonth() - now.getMonth();
		let days = endDate.getDate() - now.getDate();

		if (days < 0) {
			months--;
			const prevMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
			days += prevMonth.getDate();
		}

		if (months < 0) {
			years--;
			months += 12;
		}

		const parts = [];

		if (years > 0) parts.push(`${years} year${years > 1 ? "s" : ""}`);
		if (months > 0) parts.push(`${months} month${months > 1 ? "s" : ""}`);
		if (days > 0 || parts.length === 0)
			parts.push(`${days} day${days > 1 ? "s" : ""}`);

		return parts.length > 1
			? parts.slice(0, -1).join(", ") + " and " + parts.at(-1)
			: parts[0];
	};

	handleProceedClick = () => {
		const { status, limit_count, pkg } = this.props;
		let type_credits = parseInt(pkg.type_credits);
		let total_credits = this.state.total_credits_you_can_use + type_credits;

		if (status == 1 && total_credits >= limit_count) {
			swal({
				title: "Warning",
				text: "You can’t buy this package because your available credits exceed the limit. Limit is " + limit_count + " credits.",
				icon: "warning",
				button: "OK",
			});
			return;
		}


		this.submitCredit();
	};

	submitCredit = async () => {
		this.setState({ is_submit_credit: true })
		const { pkg, selectedStudent, studentlist, customer } = this.props;
		const mid = 100;
		const session_id = sessionStorage.getItem("manage_user_id");
		const table_log_id = sessionStorage.getItem("table_log_id");

		let student = studentlist.find((student) => student.user_id === selectedStudent);
		let expirationDate = ""

		const END_OF_DAY_TIME = '18:30:00';

		if (pkg.credits_expiry_type === 'date') {
			expirationDate = `${pkg.credits_expiry_duration} ${END_OF_DAY_TIME}`;
		} else {
			// Get current date and time
			const currentDateTime = new Date();

			// Add the specified number of days
			const daysToAdd = parseInt(pkg.credits_expiry_duration);
			const expiryDateTime = new Date(currentDateTime.getTime() + (daysToAdd * 24 * 60 * 60 * 1000));

			// Format to YYYY-MM-DD HH:mm:ss
			const year = expiryDateTime.getFullYear();
			const month = String(expiryDateTime.getMonth() + 1).padStart(2, '0');
			const day = String(expiryDateTime.getDate()).padStart(2, '0');
			const hours = String(expiryDateTime.getHours()).padStart(2, '0');
			const minutes = String(expiryDateTime.getMinutes()).padStart(2, '0');
			const seconds = String(expiryDateTime.getSeconds()).padStart(2, '0');

			expirationDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
		}
		let paid_by = sessionStorage.getItem("username");
		let userType = sessionStorage.getItem("userType");

		const { is_promo_applied, updated_amount_with_promo_code, applied_promo_code_details } = this.state;
		const payment_obj = {
			email: sessionStorage.getItem("email"),
			unit_amount: pkg.total_credit_calculated_withDiscount * 100,
			amount: is_promo_applied ? updated_amount_with_promo_code : pkg.total_credit_calculated_withDiscount,
			credits: parseInt(pkg.type_credits),
			currency_type: pkg.level_currency_type,
			type_name: pkg.type_name,
			node_mid: mid,
			currency_type_id: parseInt(pkg.currency_id),
			type_id: parseInt(pkg.type_id),
			credit_package_price_id: parseInt(pkg.level_price_id),
			expiration_date: expirationDate,
			total_credits: parseInt(pkg.type_credits),
			available_credits: parseInt(pkg.type_credits),
			used_credits: 0,
			user_id: userType === "student" ? session_id : selectedStudent,
			user_table_id: userType === "student" ? table_log_id : student.user_table_id,
			create_user_id: session_id,
			create_user_table_id: table_log_id,
			paid_by: paid_by,
			payment_method: pkg.isClaim ? "Free Credits" : "Online",
			reference_id: "N/A",
			form_list_id: 46,
			is_promo_applied: is_promo_applied ? is_promo_applied : pkg.isPromoApplied,
			usage_promo_id: is_promo_applied ? applied_promo_code_details?.id : pkg.isPromoApplied ? pkg.promo_id : null,
			promo_code: is_promo_applied ? applied_promo_code_details?.promo_code : pkg.isPromoApplied ? pkg.promo_code : null,
		};

		if (pkg.isClaim && !pkg.isDisable) {
			const paymentForManual = { ...payment_obj };
			delete paymentForManual.is_promo_applied;
			delete paymentForManual.usage_promo_id;
			delete paymentForManual.promo_code;
			await this.manualPayment(paymentForManual);
		} else {
			// Show confirmation dialog for secure payment
			const result = await swal({
				title: "",
				text: "A secure third-party payment page will open to handle your transaction safely.",
				icon: "info",
				buttons: {
					cancel: "Cancel",
					confirm: {
						text: "Proceed",
						value: true,
					}
				},
				dangerMode: false
			});

			if (result) {
				// Save pending payment info and navigate to payment terms page so the user can accept terms there
				const pending = {
					payment_obj,
					pkg: pkg,
					userType,
					selectedStudent,
					paid_by
				};
				sessionStorage.setItem('pendingAssessmentCreditEnrollment', JSON.stringify(pending));
				sessionStorage.setItem('creditPurches', 'true');

				history.push({ pathname: routes.payment_terms_condition, state: { pendingAssessmentCreditEnrollment: pending } });
				this.setState({ is_submit_credit: false });
			} else {
				this.setState({ is_submit_credit: false });
			}
		}
	};

	handleChange = (event) => {
		const { name, value } = event.target;

		if (name === 'promo_code') {
			this.setState(() => ({ [name]: value.toUpperCase(), isModified: true }));
		}
		else {
			this.setState(() => ({ [name]: value, isModified: true }));
		}
	};

	validate_promo_code = async () => {

		const confirm = await swal({
			title: "",
			text: "Apply and claim the promo code for this package",
			icon: "info",
			buttons: {
				cancel: "No",
				confirm: {
					text: "Yes",
					value: true,
				}
			},
			dangerMode: false
		});
		if (!confirm) {
			return;
		}

		const { promo_code } = this.state
		const { pkg, selectedStudent, studentlist, customer } = this.props;

		let userType = sessionStorage.getItem("userType");
		let student;

		if (selectedStudent) {
			student = studentlist?.find((student) => student.user_id === selectedStudent);
		}


		const user_id = userType === "student" ? sessionStorage.getItem("manage_user_id") : selectedStudent;
		const user_table_id = userType === "student" ? sessionStorage.getItem("table_log_id") : student?.user_table_id;

		const current_amount = {
			current_amount: pkg?.total_credit_calculated_withDiscount
		}

		if (!this.validator.allValid()) {
			this.validator.showMessages();
			this.forceUpdate();
		}

		else {

			this.setState({ is_submitting_promo_code: true })

			try {

				await PromoService.validatePromoCode(promo_code, user_id, user_table_id, current_amount, pkg.type_id)
					.then((response) => {
						if (response?.data.code === 1 && response?.data?.is_promo_code_valid) {

							if (response?.data.discount_amount >= current_amount?.current_amount) {
								sweetStatusAlert(
									"Cannot Apply Promo Code",
									`Discount value is greater than package price`,
									"info"
								)
								this.setState({ applied_promo_code_details: null, showPromoInput: false, is_promo_applied: false, updated_amount_with_promo_code: null, showPromoButton: true, is_submitting_promo_code: false });

							}
							else {
								this.promoAddedTheme()
								this.setState({
									applied_promo_code_details: response.data.promo_code_details,
									showPromoInput: false,
									showPromoButton: false,
									is_promo_applied: true,
									updated_amount_with_promo_code: response.data.total_credit_calculated_with_discount_and_promo,
									is_submitting_promo_code: false,
									promo_response: response.data
								})
								this.validator.hideMessages();
								this.validator.purgeFields();
							}

						}
						else {
							sweetStatusAlert(
								"Oops...",
								`${typeof response?.data?.message === "string" ? response.data.message : 'Failed to apply promo code'}`,
								"info"
							)
							this.setState({ applied_promo_code_details: null, showPromoInput: false, is_promo_applied: false, updated_amount_with_promo_code: null, showPromoButton: true, is_submitting_promo_code: false });
						}

					})

			} catch (error) {
				sweetStatusAlert("Error", 'Failed to apply promo code', 'error')
				this.setState({ applied_promo_code_details: null, showPromoInput: false, is_promo_applied: false, updated_amount_with_promo_code: null, showPromoButton: true, is_submitting_promo_code: false });
				this.validator.hideMessages();
				this.validator.purgeFields();
			}
		}

	}

	remove_promo_code = async () => {

		this.setState({ is_promo_applied: false, showPromoButton: true }
			, () => {
				this.setState({
					applied_promo_code_details: null,
					showPromoInput: false,
					updated_amount_with_promo_code: null,
					promo_response: null
				})
			}
		)

	}

	promoAddedTheme = () => {

		this.setState({ showAnimation: true })

		setTimeout(() => {
			this.setState({ showAnimation: false })
		}, 2000);
	};

	render() {
		const { pkg, customer } = this.props;
		const {
			promo_response,
			showPromoInput,
			showPromoButton,
			is_promo_applied,
			promo_code,
			is_submitting_promo_code,
			applied_promo_code_details,
			updated_amount_with_promo_code,
			showAnimation,
			claimedFreeCredits,
			is_submit_credit,
			isAddingToCart
		} = this.state;

		const isCardDisabled = (pkg.isClaim && pkg.isDisable) || claimedFreeCredits;
		const hasDiscount = parseInt(pkg.type_discount_rate) > 0 && !pkg.isClaim;

		return (
			<div className={`apc-card${isCardDisabled ? ' apc-card--disabled' : ''}`}>
				{showAnimation && (
					<div className="background-animation">
						<Lottie animationData={animationData} loop={true} />
					</div>
				)}
				{is_submit_credit && (
					<Backdrop
						sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
						open={is_submit_credit}
					>
						<CircularProgress color="inherit" />
					</Backdrop>
				)}
				{/* ── Header ── */}
				<div className="apc-header">
					{hasDiscount && (
						<div className="apc-discount-badge">
							<DiscountIcon sx={{ fontSize: 12 }} />
							{parseInt(pkg.type_discount_rate)}% Discount Available
						</div>
					)}
					<div className="apc-package-name">
						{pkg.level_definition} {pkg.type_name} package
					</div>
				</div>

				{/* ── Body ── */}
				<div className="apc-body">
					<div className="apc-content">
						{/* Credits + Fee Row */}
						<div className="apc-credits-row">
							<div>
								<div className="apc-credits-count">{pkg.type_credits}</div>
								<div className="apc-credits-label">{pkg.type_credits > 1 ? 'Credits' : 'Credit'}</div>
							</div>
						{pkg.isClaim ? (
							<div className="apc-fee-block">
								<div className="apc-fee-label"><MonetizationOnIcon sx={{ fontSize: 14, color: '#059669' }} /> Credit Fee</div>
								<div className="apc-fee-amount" style={{ color: '#059669' }}>Free</div>
							</div>
							) : (
							<div className="apc-fee-block">
								{(() => {
									const original = pkg.credit_amount_calculated || 0;
									let savings = pkg.savings_calculated || 0;
									if (is_promo_applied && promo_response?.discount_amount) {
										savings += promo_response.discount_amount;
									}
									const current = original - savings;
									const showDiscount = savings > 0 && current < original;
									return (
									<>
										<div className="apc-fee-label">
											<MonetizationOnIcon sx={{ fontSize: 14, color: '#6D28D9' }} /> Credit Fee
											{showDiscount && (
												<span className="apc-old-fee-label">{original} {pkg.level_currency_type}</span>
											)}
										</div>
										<div className="apc-fee-amount">
										{`${current} ${pkg.level_currency_type}`}
										</div>
									</>
								);
								})()}
							</div>
							)}
						</div>

						{/* Description */}
						{pkg.type_description && (
							<div
								className="apc-description"
								dangerouslySetInnerHTML={{ __html: pkg.type_description }}
							/>
						)}

						<hr className="apc-divider" />

						{/* Credits Active For */}
						{(pkg.credits_expiry_type && pkg.credits_expiry_duration) && (
							<div className="apc-info-item">
								<span className="apc-info-label">Credits Active for</span>
								<div>
									<span className="apc-active-badge">
										{this.calculateCreditRemainingTime(pkg.credits_expiry_type, pkg.credits_expiry_duration)}
									</span>
								</div>
							</div>
						)}

					{/* Vanishes In - Show if less than 30 days remain */}
					{this.isPackageVanish(pkg.type_end_date) && (
						<div className="apc-vanishes-row">
						<AccessTimeIcon sx={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4, color: '#DC2626' }} />
						This package vanishes in : {' '}
							<span className="apc-vanishes-time">
								{this.calculatePackageRemainingTime(pkg.type_end_date)}
							</span>
						</div>
					)}

						{/* Pricing */}
						{is_promo_applied && updated_amount_with_promo_code ? (
							<>
								{(pkg?.savings_calculated + promo_response?.discount_amount) > 0 && (
									<>
<div className="apc-price-row">
                                            <MonetizationOnIcon sx={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4, color: '#4CAF50' }} />
                                            Promo code discount : {promo_response?.discount_amount} {pkg.level_currency_type}
                                        </div>
<div className="apc-price-row">
                                            <MonetizationOnIcon sx={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4, color: '#4CAF50' }} />
                                            Your savings : {pkg?.savings_calculated + promo_response?.discount_amount} {pkg.level_currency_type}
                                        </div>
									</>
								)}
							</>
						) : (
							<>
								{pkg.isPromoApplied && (
<div className="apc-price-row">
                                            <MonetizationOnIcon sx={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4, color: '#4CAF50' }} />
                                            Promo code discount : {pkg.promo_discount_amount} {pkg.level_currency_type}
                                        </div>
								)}
								{pkg.savings_calculated > 0 && (
<div className="apc-price-row">
                                            <MonetizationOnIcon sx={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4, color: '#4CAF50' }} />
                                            Your savings : {pkg.savings_calculated} {pkg.level_currency_type}
                                        </div>
								)}
							</>
						)}
						{/* <div className="apc-total-row">
							{pkg.isClaim
								? 'Free'
								: `Total : ${is_promo_applied ? updated_amount_with_promo_code : pkg.total_credit_calculated_withDiscount} ${pkg.level_currency_type}`
							}
						</div> */}
					</div>

					{/* ── Actions ── */}
					<div className="apc-actions">
						{/* Promo Button / Input — same slot */}
						{!pkg.isClaim && (
							<div className="apc-promo-slot">
								{!pkg.isPromoApplied && showPromoButton && (
									<>
										<button className="apc-promo-trigger-btn" onClick={this.handlePromoClick}>
											<DiscountIcon sx={{ fontSize: 14 }} />
											Promo Code
										</button>
										{/* hide add-to-cart when promo input is visible */}
									    {!showPromoInput && (
											<button
												className="apc-addcart-btn"
												onClick={this.handleAddCartClick}
											>
												<ShoppingCartIcon sx={{ fontSize: 14 }} />
												Add to cart
											</button>
										)}
									</>
								)}

								{(showPromoInput || pkg.isPromoApplied) && (
									<div className="apc-promo-input-wrap">
										{pkg.isPromoApplied && pkg.promo_code && (
											<div className="apc-promo-applied-tag">Promo applied</div>
										)}
										<div className="apc-promo-input-row">
											<TextField
												name='promo_code'
												variant="outlined"
												size="small"
												disabled={pkg.isPromoApplied || is_submitting_promo_code}
												placeholder="Enter promo code"
												className="apc-promo-field"
												onChange={this.handleChange}
												value={promo_code || (pkg.isPromoApplied ? pkg.promo_code : '')}
												sx={{ flex: 1 }}
											/>
											{!pkg.isPromoApplied && (
												<>
													{is_submitting_promo_code ? (
														<CircularProgress size={24} />
													) : (
														<Button
															disabled={is_submitting_promo_code || promo_code === ''}
															variant="contained"
															className="apc-redeem-btn"
															onClick={this.validate_promo_code}
														>
															Redeem
														</Button>
													)}
												</>
											)}
											{!pkg.isPromoApplied && (
												<IconButton
													disabled={is_submitting_promo_code}
													onClick={this.handleCloseClick}
													size="small"
													sx={{ padding: '2px' }}
												>
													<CloseIcon sx={{ fontSize: '16px' }} />
												</IconButton>
											)}
										</div>
									</div>
								)}
							</div>
						)}

						{/* Proceed to Pay */}
						<Button
							variant="contained"
							onClick={this.handleProceedClick}
							disabled={(is_promo_applied && updated_amount_with_promo_code < 1) || (!pkg.isClaim && pkg.total_credit_calculated_withDiscount < 1) || pkg.isDisable || showPromoInput}
							className={isCardDisabled ? "apc-proceed-btn apc-proceed-btn--claimed" : "apc-proceed-btn"}
							fullWidth
						>
							{pkg.isClaim && !pkg.isDisable
								? "Claim"
								: (pkg.isClaim && pkg.isDisable || claimedFreeCredits)
									? "Already claimed"
									: `Proceed to Pay - ${is_promo_applied ? updated_amount_with_promo_code : pkg.total_credit_calculated_withDiscount} ${pkg.level_currency_type}`}
						</Button>
					</div>
				</div>
			</div>
		);
	}
}

export default BasicCard;

